import React from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// Row card shell used by each weekly report entry.
// Keeps border/highlight/layout concerns isolated from row business logic.

type WeeklyReportRowCardProps = {
  isLocked: boolean;
  isRowSaving: boolean;
  shouldHighlightRow: boolean;
  children: React.ReactNode;
};

const SAVING_COLOR = '#21e77a';
const DARK_ROW = '#111a2b';
const DARK_ROW_INNER = '#121C2E';
const DARK_BORDER = '#26384f';

export const WeeklyReportRowCard: React.FC<WeeklyReportRowCardProps> = ({
  isLocked,
  isRowSaving,
  shouldHighlightRow,
  children,
}) => {
  const { palette } = useTheme();
  const isDark = palette.mode === 'dark';

  return (
    <Box
      className={`wr-card${isLocked ? ' is-locked' : ''}`}
      aria-busy={isRowSaving}
      sx={{
        height: '100%',
        border: isDark ? `1px solid ${DARK_BORDER}` : '1px solid #e0e0e0',
        borderRadius: 1,
        backgroundColor: isDark ? DARK_ROW : '#fff',
        boxShadow: isDark ? '0 4px 10px rgba(0,0,0,0.28)' : '0 4px 6px rgba(0,0,0,0.1)',
        overflow: 'hidden',
        p: 0,
        ...(shouldHighlightRow
          ? { outline: `3px solid ${SAVING_COLOR}`, outlineOffset: '-3px' }
          : null),
      }}
    >
      <Box
        className="articles"
        sx={{
          display: 'grid',
          gridTemplateColumns: 'minmax(0, 2fr) minmax(0, 1fr)',
          columnGap: '0px',
          rowGap: 0.5,
          backgroundColor: isDark ? DARK_ROW_INNER : '#f9f9fb',
          p: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
